var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leaderboard-loading-indicator"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"quiz--result"},[_vm._v("\n      "+_vm._s(_vm.$t("loadingResult"))+"...\n    ")]),_c('Loading',{staticStyle:{"margin":"0 auto"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }